<template>
  <div class="bg-image">
    <div class="sub-bg-image">
      <div class="login-container">
        <div class="form-title">
          <h1>
            <b>Board</b>
            Yönetim Paneli
          </h1>
        </div>
        <div class="card-body">
          <p class="login-box-msg">{{ $store.getters.getMessage }}</p>

          <form @submit.prevent="onSubmit">
            <div class="input-group mb-4">
              <div class="input-box">
                <input type="text" v-model="user.ga" required="Required" />
                <span>GA Kodu Giriniz</span>
                <div>
                  <i class="fas fa-user-lock"></i>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <button type="submit" class="btn btn-outline">
                  Giriş Yap
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        ga: "",
      },
    };
  },
  methods: {
    onSubmit() {
      this.$store.dispatch("ga", { ...this.user }).then((response) => {
        if (this.$store.getters.isGa) this.$router.push("/");
      });
    },
  },
};
</script>

<style scoped>
:root {
  --dark: rgb(40, 40, 40);
  --darker: rgb(18, 18, 18);
  --light: #fff;
}

.btn {
  outline: none;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  font-size: 1.2rem;
  font-weight: 400;
  cursor: pointer;
  border-radius: 6px;
  transition: 0.3s all ease;
}

.btn-primary {
  border: 2px solid var(--darker);
  background: var(--darker);
  color: var(--light);
}

.btn-outline {
  border: 2px solid var(--light);
  background: inherit;
  color: var(--light);
}

.btn-outline:hover {
  border: 2px solid var(--light);
  background: var(--light);
  color: var(--darker);
  font-weight: 600;
}

.btn-gradient {
  border: none;
  color: white;
  background: linear-gradient(0.25turn, #151616, #1b1d18, #151616);
}

.bg-image {
  background-image: url(/src/assets/dist/img/bg/login-bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sub-bg-image {
  background-image: url(/src/assets/dist/img/bg/login-bg-2.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
  height: 500px;
  width: 1020px;
  display: flex;
  align-items: center;
  border-radius: 20px;
}

.login-container {
  border: none;
  border-radius: 10px;
  padding: 10px 30px;
}

.form-title {
  color: white;
}

.input-box {
  position: relative;
  width: 100%;
  display: flex;
}

.input-box i {
  color: white;
  font-size: 1.1rem;
  width: 4rem;
  text-align: center;
  padding: 0.64rem 1rem;
  border-right: 1px solid rgba(255, 255, 255, 0.25);
  border-top: 1px solid rgba(255, 255, 255, 0.25);
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 0 6px 6px 0;
}


.input-box input {
  width: 100%;
  height: 40px;
  padding: 10px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: inherit;
  border-radius: 6px 0 0 6px;
  outline: none;
  color: white;
  font-size: 1rem;
}

.input-box input:-webkit-autofill,
.input-box input-webkit-autofill:active,
.input-box input-webkit-autofill:focus {
  color: inherit !important;
}

.input-box span {
  position: absolute;
  left: 0;
  padding: 10px;
  pointer-events: none;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.25);
  border-color: transparent;
  transition: 0.3s all ease-out;
}

.input-box input:valid~span,
.input-box input:focus~span {
  color: white;
  transform: translateX(15px) translateY(-13px);
  font-size: 0.8rem;
  background: var(--dark);
  border-radius: 8px;
  padding: 0px 5px;
  border-left: 1px solid var(--dark);
  border-right: 1px solid var(--dark);
}
</style>



// WEBPACK FOOTER //
// src/components/Ga.vue